import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  referenceIdsList: [],
};

const reducers = {
  fetchReferenceIdsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchReferenceIdsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchReferenceIdsSuccess(state, { payload }) {
    return R.assoc('referenceIdsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'referenceIds',
  reducers,
});

const { fetchReferenceIdsPending, fetchReferenceIdsSuccess, fetchReferenceIdsError } = actions;

// Selectors
const referenceIdsSelector = state => state.pto.referenceIds.referenceIdsList;
export const getReferenceIdOptions = createSelector(referenceIdsSelector, referenceIds =>
  referenceIds.map(refId => ({
    label: `${refId}`,
    value: `${refId}`,
  }))
);

// Actions
let fetchController;
export function fetchReferenceIds() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchReferenceIdsPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-reference-ids-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchReferenceIdsError(''));
        dispatch(fetchReferenceIdsSuccess(res.data));
        dispatch(fetchReferenceIdsPending(false));
      });
  };
}

export default reducer;
